// @flow
import type { Node } from 'react';
import React, { useState, useContext } from 'react';
import { ModalProvider, BaseModalBackground } from 'styled-react-modal';
import styled from 'styled-components/macro';

type contextType = {
  openedModal: string | null,
  setOpenedModal: (modal: string | null) => void,
  closeModal: () => void,
};

export const ModalContext: React$Context<contextType> = React.createContext<contextType>({
  openedModal: null,
  setOpenedModal: () => {},
  closeModal: () => {},
});

const FadingBackground = styled(BaseModalBackground)`
  opacity: ${(props) => props.opacity};
  transition: opacity ease 200ms;
  z-index: ${(props) => props.theme.zIndex.drawer}; //1200
`;

const ModalProviderComponent = ({ children }: { children: Node }): Node => {
  const [openedModal, setOpenedModal] = useState<string | null>(null);
  const closeModal = () => setOpenedModal(null);

  window.onpopstate = closeModal;

  return (
    <ModalProvider backgroundComponent={FadingBackground}>
      <ModalContext.Provider value={{ openedModal, setOpenedModal, closeModal }}>{children}</ModalContext.Provider>
    </ModalProvider>
  );
};

export default ModalProviderComponent;

export const useModalContext = (): contextType => useContext(ModalContext);
